import type { ComponentType } from "react";

export type PillTab = {
  key: number;
  label: string;
  icon?: ComponentType<{ width?: number; height?: number }>;
};

export default function PillTabs({
  tabs,
  activeTab,
  onTabChange,
}: {
  tabs: PillTab[];
  activeTab: number;
  onTabChange: (key: number) => void;
}) {
  return (
    <>
      <style>{`
        .pill-tabs { scrollbar-width: none; }
        .pill-tabs::-webkit-scrollbar { display: none; }
        .pill-tab {
          border: 0;
          background: transparent;
          color: #6c757d;
          white-space: nowrap;
          font-weight: 600;
          transition: background .15s, color .15s;
        }
        .pill-tab:hover { background: #f6f6f4; color: #212529; }
        .pill-tab.active,
        .pill-tab.active:hover {
          background: #fff1e7;
          color: #ff7722;
          font-weight: 700;
        }
      `}</style>
      <div
        role="tablist"
        className="pill-tabs bg-white rounded-4 shadow-sm p-2 d-flex flex-nowrap gap-1 overflow-auto"
      >
        {tabs.map(({ key, label, icon: Icon }) => {
          const active = activeTab === key;
          return (
            <button
              key={key}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onTabChange(key)}
              className={`pill-tab d-flex align-items-center gap-2 rounded-3 px-3 py-2 ${
                active ? "active" : ""
              }`}
            >
              {Icon && <Icon width={18} height={18} />}
              {label}
            </button>
          );
        })}
      </div>
    </>
  );
}
